class RacingEntriesTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.tableBody = self.elem.querySelector("[data-racing-entries-table-body]");
        self.apiUrl = self.elem.dataset.apiUrl;
    }

    async init() {
        let self = this;

        if (!self.apiUrl) {
            console.error("No API URL defined on table element.");
            return;
        }

        try {
            const response = await fetch(self.apiUrl);
            if (!response.ok) throw new Error(`API request failed: ${response.status}`);
            let data = await response.json();

            // Sort entries first by date, then by time
            const entries = (data.entries || []).sort((a, b) => {
                const dateA = new Date(`${a.raceDate}T${a.raceTime}`);
                const dateB = new Date(`${b.raceDate}T${b.raceTime}`);
                return dateA - dateB;
            });

            self.populateTable(entries);
        } catch (err) {
            console.error("Error fetching racing entries:", err);
        }
    }

    populateTable(entries) {
        self = this;

        // Clear existing table body
        self.tableBody.textContent = "";

        if (!entries.length) {
            const row = document.createElement("tr");
            const cell = document.createElement("td");
            cell.colSpan = 5; // total number of columns
            cell.classList.add("text-center");
            cell.textContent = "No upcoming entries";
            row.appendChild(cell);
            self.tableBody.appendChild(row);
            return;
        }

        entries.forEach(entry => {
            const row = document.createElement("tr");

            if (entry.declared === "true") {
                row.classList.add("declared");
            }

            // Format raceDate to DD.MM.YYYY
            const raceDate = new Date(entry.raceDate);
            const formattedDate = `${String(raceDate.getDate()).padStart(2,'0')}.${String(raceDate.getMonth()+1).padStart(2,'0')}.${raceDate.getFullYear()}`;

            const horseCell = document.createElement("td");
            horseCell.textContent = entry.animalName;
            horseCell.classList.add("text-uppercase", "fw-bold");
            row.appendChild(horseCell);

            const racecourseCell = document.createElement("td");
            racecourseCell.textContent = entry.raceCourse;
            row.appendChild(racecourseCell);

            const raceDetailsCell = document.createElement("td");
            raceDetailsCell.textContent = entry.raceDetails;
            row.appendChild(raceDetailsCell);

            const raceDateCell = document.createElement("td");
            raceDateCell.textContent = formattedDate;
            row.appendChild(raceDateCell);

            const raceTimeCell = document.createElement("td");
            raceTimeCell.textContent = entry.raceTime;
            row.appendChild(raceTimeCell);

            self.tableBody.appendChild(row);
        });
    }
}

export default RacingEntriesTable;